const equivalences: { [key: number]: string } = {
  1: 'STP',
  2: 'SEF',
  3: 'IAE',
  4: 'DPG',
  5: 'ECN',
  6: 'POB',
  7: 'ACR',
  8: 'ACR'
}

export class DocumentationType {
  private _documentationType: string

  public static fromIntegerCode (code: number): DocumentationType {
    const parsedType = equivalences[code]
    return new DocumentationType(parsedType)
  }

  constructor (documentationType: string) {
    const allowedValues = Object.values(equivalences)
    if (allowedValues.indexOf(documentationType) === -1) {
      throw new RangeError(`Value provided (${documentationType}) not valid for DocumentationType`)
    }
    this._documentationType = documentationType
  }

  value (): string {
    return this._documentationType
  }
}
